module.exports = __webpack_public_path__ + "static/media/Appcenter.44d36e4c.svg";